<template>
    <div>
      <img @click="showModal = true" v-if="currentImageSrc" v-bind:src="currentImageSrc" alt="aperçu">
      <img @click="showModal = true" v-else src="http://lorempixel.com/640/480/" alt="aperçu">
      <modal  size="large" v-if="showModal" @close="showModal = false">
          <div slot="header">Librairie d'images</div>
          <imageLibrary slot="body" @close="showModal = false" @imageChosen="updateImageSrc"></imageLibrary>
          <div slot="footer" class="panel-footer" >
              <div class="row columns">
                  <div class="large-2 columns">
                      <button @click="showModal = false" class="light-grey-button full-width">Annuler</button>
                  </div>
                  <div class="large-5 columns large-offset-5">
                      <input type="file" @change="onFileChange">
                      <modal  size="large" v-if="showCropperModal">
                          <div slot="header">Retouches d'images</div>
                          <div slot="body">
                              <imageCropper
                                @imageChosen="updateImageSrc"
                                @closeCropper="showCropperModal=false"
                                :fileToCrop="fileChosen">
                              </imageCropper>
                          </div>
                          <div slot="footer">
                          </div>
                     </modal>
                  </div>
                  <div class="clear"></div>
              </div>
          </div>
      </modal>
    </div>
</template>

<script>

import spinner from './spinner.vue'
import modal from './modal.vue'
import imageLibrary from './image-editor/image-library.vue'
import imageCropper from './image-editor/image-cropper.vue'

export default {
  name: 'imageEditor',
  components: {
    spinner,
    imageLibrary,
    imageCropper,
    modal
  },
  props: {
    'imageSrc': null
  },
  methods: {
    updateImageSrc (src) {
      this.currentImageSrc = src
      this.showModal = false
      this.$emit('ImageEditorClosed')
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.fileChosen = files[0]
      this.showCropperModal = true
    }
  },
  data () {
    return {
      currentImageSrc: this.imageSrc,
      showModal: false,
      showCropperModal: false,
      fileChosen: null
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position:fixed
}
</style>



// WEBPACK FOOTER //
// image-editor.vue?78b57ab0